import React from 'react';
import View from 'components/main/pages/home/views/View';

import Tools from './contents/Tools';
import Games from './contents/Games';
import Schools from './contents/Schools';
import Courses from './contents/Courses';
import Subjects from './contents/Subjects';

class StudentHome extends View {

  render() {
    this.init(this.props);
    return(
      <div id='home' style={this.viewStyle()} onScroll={()=>{this.actions.main.setStatus('ready')}}>
        <Tools app={this.app}/>
        <Schools app={this.app}/>
        <Games app={this.app}/>
        <Courses app={this.app}/>
        <Subjects app={this.app}/>
      </div>
    )
  }
}

export default StudentHome;
